import { P2GBox } from '@parcel2go/core-ui';
import { useCallback, useEffect, useState } from 'react';
import { GetQuoteValidationResponse, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import Loading from '../../../../../components/loading/Loading';
import { CustomsSelection } from '../CustomsSelection';
import { SidePanelSections } from '../../../../../components/sidepanel-section';
import { uid } from '../../../lib/helpers/uid';
import ShouldRequoteOnTaxStatusChange from '../../../lib/helpers/ShouldRequoteOnTaxStatusChange';

interface props {
  onUpdate?: (item: SmartSendItemApiModel) => void;
  item: SmartSendItemApiModel;
  getValidation: () => Promise<GetQuoteValidationResponse>;
}

export const ItemTaxIds: React.FC<props> = (props) => {
  const [loading, setLoading] = useState(true);
  const [validation, setValidation] = useState<GetQuoteValidationResponse>(null);
  const [quoteKey, setQuoteKey] = useState<string>(uid());

  const getData = useCallback(async () => {
    const v = await props.getValidation();
    setValidation(v);
    setLoading(false);
  }, [props]);

  useEffect(() => {
    getData();
  }, [quoteKey, getData]);

  if (loading) {
    return <Loading />;
  }

  return (
    <SidePanelSections>
      <P2GBox textAlign="left">
        {validation ? (
          <CustomsSelection
            sender={props.item.Sender}
            recipient={props.item.Recipient}
            itemMeta={props.item.Meta}
            marketplaceIds={props.item.MarketplaceOrderLines.map((x) => x.Source?.Id)}
            validation={{
              SenderValidation: validation.SenderValidation,
              RecipientValidation: validation.RecipientValidation,
              ItemValidation: []
            }}
            onUpdate={(s, r, m) => {
              const i = { ...props.item, Sender: { ...s }, Recipient: { ...r } };
              for (const p in m) {
                i.Meta[p] = m[p];
              }
              props.onUpdate(i);
              if (ShouldRequoteOnTaxStatusChange(props.item, i)) {
                setQuoteKey(uid());
              }
            }}
            duties={null}
          />
        ) : (
          <P2GBox mt={2}>
            <Loading />
          </P2GBox>
        )}
      </P2GBox>
    </SidePanelSections>
  );
};
